<template>
  <div>
    <div
      class="time-sheet"
      v-if="month && employee_id && employeeTimesheetSummary"
    >
      <div class="time-sheet-statical"
      :class="
        employeeTimesheetSummary.isSubmitted
          ? 'submit--success'
          : ''
      "
      >
        <div
          v-if="employeeTimesheetSummary.isSubmitted"
          class="submit-tick--success"
        >
          {{ $t("detail_employee_timesheet.title.submited") }}
        </div>
        <div class="statical-header">
          <div class="header-title">
            Chi tiết công số -
            {{
              employeeTimesheetSummary.employee_name +
              ` (${employeeTimesheetSummary.employee_id})`
            }}
            <!-- {{ $t("detail_employee_timesheet.title.timesheet_statical") }} -->
          </div>
          <!-- <div class="header-time-remain submited-time" v-if="isSubmited">
          <img src="/img/icons/checked-icon.svg" alt="time remain" /> Đã submit
          công
        </div> -->
          <div class="month-title">Tháng {{ month }}</div>
        </div>
        <div class="statical-content">
          <a-row :gutter="[12, 12]">
            <a-col class="statical-summary">
              <div class="statical-item">
                <div class="item-header text-center">
                  {{ $t("detail_employee_timesheet.title.total_timesheet") }}
                  <div class="text_color--blue fs-70 fw-700">
                    {{
                      employeeTimesheetSummary.standardAttendanceInMonth || 0
                    }}
                  </div>
                  <div class="text_color--grey">
                    {{ $t("detail_employee_timesheet.title.date") }}
                  </div>
                </div>
                <div class="item-footer text-center">
                  <div class="mt-4">
                    {{ $t("detail_employee_timesheet.title.time_work") }}
                  </div>
                  <div class="text_color--green time-item">
                    {{  employeeTimesheetSummary.employee_work_shift.morning_shift_start.slice(0, 5)  }}-{{ employeeTimesheetSummary.employee_work_shift.afternoon_shift_end.slice(0, 5) }}
                  </div>
                </div>
              </div>
              <div class="statical-item">
                <div class="item-header text-center">
                  {{
                    $t("detail_employee_timesheet.title.total_real_timesheet")
                  }}
                  <div class="text_color--red fs-70 fw-700">
                    {{
                      formatNumber(
                        employeeTimesheetSummary.work_time_pay_day || 0
                      )
                    }}
                  </div>
                  <div class="text_color--grey">
                    {{ $t("detail_employee_timesheet.title.date") }}
                  </div>
                </div>
                <div class="item-footer text-center">
                  <div>
                    {{ $t("detail_employee_timesheet.title.miss_timesheet") }}
                    <span class="text_color--red">
                      {{
                        formatNumber(
                          employeeTimesheetSummary.miss_timesheet * 8 || 0
                        )
                      }}
                      {{ $t("detail_employee_timesheet.title.hour") }}
                      ({{ employeeTimesheetSummary.miss_timesheet }}
                      {{ $t("detail_employee_timesheet.title.date") }})
                    </span>
                  </div>
                </div>
              </div>
            </a-col>
            <a-col :md="24">
              <div class="statical-item">
                <div class="item-header header-title">
                  {{
                    $t("detail_employee_timesheet.title.detail_real_timesheet")
                  }}
                </div>
                <div class="item-footer">
                  <a-row class="real-timesheet-list">
                    <div class="real-timesheet-item">
                      {{ $t("detail_employee_timesheet.label.real_timesheet") }}
                      <span class="text_color--green">
                        {{
                          formatNumber(
                            employeeTimesheetSummary.work_time_real_day || 0
                          )
                        }}
                        {{ $t("detail_employee_timesheet.title.date") }}</span
                      >
                    </div>
                    <div class="real-timesheet-item item-mobile">
                      {{ $t("detail_employee_timesheet.label.ot_timesheet") }}
                      <span class="text_color--green">
                        {{
                          formatNumber(
                            employeeTimesheetSummary.ot_150_day +
                              employeeTimesheetSummary.ot_200_day || 0
                          )
                        }}
                        {{ $t("detail_employee_timesheet.title.date") }}</span
                      >
                    </div>
                    <div class="real-timesheet-item">
                      {{
                        $t("detail_employee_timesheet.label.sabbatical_leave")
                      }}
                      <span class="text_color--green">
                        {{
                          formatNumber(employeeTimesheetSummary.day_off || 0)
                        }}
                        {{ $t("detail_employee_timesheet.title.date") }}</span
                      >
                    </div>
                    <div class="real-timesheet-item">
                      {{ $t("detail_employee_timesheet.label.leave") }}
                      <span class="text_color--green">
                        {{
                          formatNumber(
                            employeeTimesheetSummary.unpaid_leave || 0
                          )
                        }}
                        {{ $t("detail_employee_timesheet.title.date") }}</span
                      >
                    </div>
                    <div class="real-timesheet-item" :md="6" :span="12">
                      {{
                        $t("detail_employee_timesheet.label.added_timesheet")
                      }}
                      <span class="text_color--green">
                        {{
                          formatNumber(
                            employeeTimesheetSummary.compensation_day * 8 || 0
                          )
                        }}
                        {{ $t("detail_employee_timesheet.title.hour") }}
                        ({{
                          formatNumber(
                            employeeTimesheetSummary.compensation_day || 0
                          )
                        }}
                        {{ $t("detail_employee_timesheet.title.date") }})
                      </span>
                    </div>
                    <!-- <div class="real-timesheet-item">
                      {{ $t("detail_employee_timesheet.label.physiological") }}
                      <span class="text_color--green">
                      {{ formatNumber(employeeTimesheetSummary.physiological || 0) }}
                      {{ $t("detail_employee_timesheet.label.date") }}</span
                      >
                    </div> -->
                  </a-row>
                </div>
              </div>
            </a-col>
            <a-col :md="6">
              <div class="statical-item">
                <div class="item-header header-title">
                  <!-- <router-link
                  :to="{
                    name: 'Overtime Request',
                    query: {
                      month: moment(searchData.month, 'M/YYYY').format(
                        'MM/YYYY'
                      ),
                      currentPage: 1,
                      perPage: 10,
                      sortColumn: 'work_date',
                      sortBy: 'DESC',
                    },
                  }"
                  class="header-title"
                > -->
                  {{ $t("detail_employee_timesheet.label.ot_request_status") }}
                  <!-- </router-link> -->
                </div>
                <div class="item-footer">
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_accepted_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{ employeeTotalRequest.totalOTRequestStatus["2"] }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_reject_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{ employeeTotalRequest.totalOTRequestStatus["3"] }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_pending_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{ employeeTotalRequest.totalOTRequestStatus["1"] }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                </div>
              </div>
            </a-col>
            <a-col :md="6">
              <div class="statical-item">
                <div class="item-header header-title">
                  <!-- <router-link
                  :to="{
                    name: 'Additional Timesheet',
                    query: {
                      month: moment(searchData.month, 'M/YYYY').format(
                        'MM/YYYY'
                      ),
                      currentPage: 1,
                      perPage: 10,
                      sortColumn: 'work_date',
                      sortBy: 'DESC',
                    },
                  }"
                  class="header-title"
                > -->
                  {{
                    $t(
                      "detail_employee_timesheet.label.timesheet_request_status"
                    )
                  }}
                  <!-- </router-link> -->
                </div>
                <div class="item-footer">
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_accepted_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{
                        employeeTotalRequest.totalTimesheetRequestStatus["2"]
                      }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_reject_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{
                        employeeTotalRequest.totalTimesheetRequestStatus["3"]
                      }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_pending_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{
                        employeeTotalRequest.totalTimesheetRequestStatus["1"]
                      }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                </div>
              </div>
            </a-col>
            <a-col :md="6">
              <div class="statical-item">
                <div class="item-header header-title">
                  <!-- <router-link
                  :to="{
                    name: 'Sabbatical leave request',
                    query: {
                      startDate: moment(searchData.month, 'MM/YYYY')
                        .startOf('month')
                        .format('DD-MM-YYYY'),
                      endDate: moment(searchData.month, 'MM/YYYY')
                        .endOf('month')
                        .format('DD-MM-YYYY'),
                      currentPage: 1,
                      perPage: 10,
                      sortColumn: 'updated_at',
                      sortBy: 'DESC',
                    },
                  }"
                  class="header-title"
                > -->
                  {{
                    $t(
                      "detail_employee_timesheet.label.sabbatical_leave_request_status"
                    )
                  }}
                  <!-- </router-link> -->
                </div>
                <div class="item-footer">
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_accepted_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{
                        employeeTotalRequest.totalSabbaticalRequestStatus["2"]
                      }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_reject_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{
                        employeeTotalRequest.totalSabbaticalRequestStatus["3"]
                      }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_pending_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{
                        employeeTotalRequest.totalSabbaticalRequestStatus["1"]
                      }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                </div>
              </div>
            </a-col>
            <a-col :md="6">
              <div class="statical-item">
                <div class="item-header header-title">
                  <!-- <router-link
                  :to="{
                    name: 'RemoteRequest',
                    query: {
                      startDate: moment(searchData.month, 'MM/YYYY')
                        .startOf('month')
                        .format('DD-MM-YYYY'),
                      endDate: moment(searchData.month, 'MM/YYYY')
                        .endOf('month')
                        .format('DD-MM-YYYY'),
                      currentPage: 1,
                      perPage: 10,
                      sortColumn: 'updated_at',
                      sortBy: 'DESC',
                    },
                  }"
                  class="header-title"
                > -->
                  {{
                    $t("detail_employee_timesheet.label.remote_request_status")
                  }}
                  <!-- </router-link> -->
                </div>
                <div class="item-footer">
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_accepted_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{ employeeTotalRequest.totalRemoteRequestStatus["2"] }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_reject_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{ employeeTotalRequest.totalRemoteRequestStatus["3"] }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                  <div class="list-item">
                    <div class="item-label">
                      {{
                        $t(
                          "detail_employee_timesheet.label.total_pending_request"
                        )
                      }}
                    </div>
                    <span class="text_color--green minw-50"
                      >{{ employeeTotalRequest.totalRemoteRequestStatus["1"] }}
                      {{ $t("detail_employee_timesheet.title.request") }}</span
                    >
                  </div>
                </div>
              </div>
            </a-col>
          </a-row>
        </div>
      </div>
      <div class="table-list">
        <CCard>
          <CCardBody>
            <div class="card__header">
              <div class="card-header__content">
                {{ $t("page_title.page_timesheet_list") }}
              </div>
            </div>
            <div class="table-wrapper">
              <table class="table-content">
                <thead class="table-header">
                  <tr>
                    <th class="cl-pointer" rowspan="2">
                      {{ $t("timeSheets.date") }}
                    </th>
                    <th colspan="2">
                      {{
                        $t(
                          "detail_employee_timesheet.table.time_checkin_checkout"
                        )
                      }}
                    </th>
                    <th colspan="2">
                      {{ $t("detail_employee_timesheet.table.time_pay") }}
                    </th>
                    <th colspan="3">
                      {{ $t("detail_employee_timesheet.table.real_timesheet") }}
                    </th>
                    <th rowspan="2">
                      {{ $t("detail_employee_timesheet.table.status") }}
                    </th>
                  </tr>
                  <tr>
                    <th>
                      {{
                        $t("detail_employee_timesheet.table.start_time_real")
                      }}
                    </th>
                    <th>
                      {{ $t("detail_employee_timesheet.table.end_time_real") }}
                    </th>
                    <th>
                      {{ $t("detail_employee_timesheet.table.time_start") }}
                    </th>
                    <th>
                      {{ $t("detail_employee_timesheet.table.time_end") }}
                    </th>
                    <th>
                      {{
                        $t("detail_employee_timesheet.table.nomal_timesheet")
                      }}
                    </th>
                    <th>
                      {{ $t("detail_employee_timesheet.table.ot_timesheet") }}
                    </th>
                    <th>{{ $t("detail_employee_timesheet.table.total") }}</th>
                  </tr>
                </thead>
                <tbody class="table-body">
                  <template
                    v-if="
                      employeeTimesheetDetail &&
                      employeeTimesheetDetail.length > 0
                    "
                  >
                    <tr
                      v-for="(timeSheet, index) in employeeTimesheetDetail"
                      :key="index"
                      :class="classDayOff(timeSheet.day_off_user)"
                    >
                      <td>
                        <div class="work_date">
                          <div>
                            {{ timeSheet.work_date }}
                          </div>
                          <div>
                            {{ $t(`timeSheets.${timeSheet.day_of_week}`) }}
                          </div>
                        </div>
                      </td>
                      <td>
                        <span
                          v-if="timeSheet.start_time_real"
                          class="employee__badge"
                        >
                          <img
                            :class="
                              timeSheet.start_time_real > timeSheet.start_time_pay
                                ? 'img__higher'
                                : 'img__lower'
                            "
                            src="../../assets/icons/clock.svg"
                            alt=""
                          />
                          <span
                            :class="
                              timeSheet.start_time_real > timeSheet.start_time_pay
                                ? 'span__higher'
                                : 'span__lower'
                            "
                          >
                            {{ timeSheet.start_time_real }}
                          </span>
                        </span>
                        <div v-else>-</div>
                      </td>
                      <td>
                        <span
                          v-if="timeSheet.end_time_real"
                          class="employee__badge"
                        >
                          <img
                            :class="
                              timeSheet.end_time_real < timeSheet.end_time_pay
                                ? 'img__higher'
                                : 'img__lower'
                            "
                            src="../../assets/icons/clock.svg"
                            alt=""
                          />
                          <span
                            :class="
                              timeSheet.end_time_real < timeSheet.end_time_pay
                                ? 'span__higher'
                                : 'span__lower'
                            "
                          >
                            {{ timeSheet.end_time_real }}
                          </span>
                        </span>
                        <div v-else>-</div>
                      </td>
                      <!-- <td>
                      {{
                        timeSheet.start_time_pay
                          ? timeSheet.start_time_pay
                          : "-"
                      }}
                    </td> -->
                      <!-- <td>
                      {{
                        timeSheet.end_time_pay ? timeSheet.end_time_pay : "-"
                      }}
                    </td> -->
                      <td>
                        {{
                          timeSheet.day_off_user === 0 &&
                          timeSheet.work_time_pay_summary
                            ? timeSheet.start_time_pay.slice(0, 5)
                            : "-"
                        }}
                      </td>
                      <td>
                        {{
                          timeSheet.day_off_user === 0 &&
                          timeSheet.work_time_pay_summary
                            ? timeSheet.end_time_pay.slice(0, 5)
                            : "-"
                        }}
                      </td>
                      <td>
                        <span
                          v-if="
                            timeSheet.work_time_pay_summary ||
                            (timeSheet.day_off_user == 2 &&
                              checkIsWeekend(timeSheet.day_of_week) == false)
                          "
                          :class="
                            timeSheet.work_time_pay_summary < '08:00'
                              ? 'span__higher'
                              : ''
                          "
                        >
                          {{ timeSheet.work_time_pay_summary }}
                        </span>
                        <span v-else> - </span>
                      </td>
                      <td>
                        <span
                          v-if="
                            timeSheet.ot_150 && timeSheet.ot_150 !== '00:00'
                          "
                        >
                          {{ `${timeSheet.ot_150} x 150%` }}
                        </span>
                        <span
                          v-else-if="
                            timeSheet.ot_200 && timeSheet.ot_200 !== '00:00'
                          "
                        >
                          {{ `${timeSheet.ot_200} x 200%` }}
                        </span>
                        <span v-else> - </span>
                      </td>
                      <td>
                        {{ timeSheet.all_time }}
                      </td>

                      <td>
                        <span
                          class="employee__dayoff"
                          v-if="timeSheet.day_off_user === 1"
                        >
                          Cuối tuần
                        </span>
                        <span
                          class="employee__holiday-off"
                          v-else-if="timeSheet.day_off_user === 2"
                        >
                          Ngày lễ
                        </span>
                        <span
                          class="employee__holiday-off"
                          v-else-if="timeSheet.day_off_user === 3"
                        >
                          Nghỉ bù lễ
                        </span>
                        <span
                          class="employee__dayoff"
                          v-else-if="
                            timeSheet.paid_leave +
                              timeSheet.compensation_leave + timeSheet.physiological_leave_minute >
                              0 && timeSheet.day_off_user == 0
                          "
                        >
                          Nghỉ phép
                        </span>
                        <span
                          class="employee__leave"
                          v-else-if="
                            (!timeSheet.work_time_pay ||
                              timeSheet.work_time_pay == '00:00') &&
                            timeSheet.day_off_user === 0 &&
                            timeSheet.physiological_leave_minute === 0
                          "
                        >
                          Nghỉ không lương
                        </span>
                        <span class="employee__work" v-else> Đi làm </span>
                          <br>
                        <span class="employee__physiological font-weight-bold"
                          v-if="timeSheet.physiological_leave_minute != 0"
                        > Nghỉ sinh lý:  {{timeSheet.physiological_leave_minute}} phút</span>
                      </td>
                    </tr>
                  </template>
                  <template v-else>
                    <tr>
                      <td colspan="13" class="text-center">
                        <span class="table-empty">{{
                          $t("table.label_data_not_found")
                        }}</span>
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </CCardBody>
        </CCard>
      </div>
    </div>
    <div v-else>Không có thông tin nhân viên</div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

import { formatNumber } from "@/utils/ui";
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
  name: "DetaiTimesheetEmployee",
  metaInfo() {
    return {
      title: this.$t("page_title.page_detail_timesheet_employeee"),
      titleTemplate: "%s | " + this.$t("page_title.head_title"),
    };
  },
  data() {
    return {
      month: "",
      employee_id: "",
      //   isSubmitable: true,
    };
  },
  async created() {
    let params = this.$route.query;
    if (params?.month && params?.id) {
      this.month = params.month;
      this.employee_id = params.id;
      await this.fetchAllData();
      //   console.log("123123133",this.employeeTotalRequest);
      //   console.log("1",this.employeeTimesheetSummary);
      //   console.log("2",this.employeeTimesheetDetail);
    }

    // await this.$root.$loading.finish();
  },
  computed: {
    ...mapGetters({
      employeeTimesheetDetail: "timeSheet/employeeTimesheetDetail",
      employeeTimesheetSummary: "timeSheet/employeeTimesheetSummary",
      employeeTotalRequest: "timeSheet/employeeTotalRequest",
      //   sumittedInfomation: "commons/sumittedInfomation",
    }),
  },
  methods: {
    ...mapActions("layout", ["setLoading"]),
    moment,
    sumWorkTime(work_time, ot_time) {
      const realWorkTime = moment(work_time, "HH:mm")
        // .subtract(moment.duration({ hours: 1, minutes: 30 }))
        .format("HH:mm");
      var workTime = moment.duration(realWorkTime);

      // subtract rounding error
      if (work_time == "08:01") {
        workTime = workTime.subtract(moment.duration({ minutes: 1 }));
      }
      if (work_time == "08:02") {
        workTime = workTime.subtract(moment.duration({ minutes: 2 }));
      }

      const realOtTime = moment.duration(ot_time);
      const totalTime = workTime.add(realOtTime);

      let hours =
        totalTime.hours() < 10 ? `0${totalTime.hours()}` : totalTime.hours();
      let minutes =
        totalTime.minutes() < 10
          ? `0${totalTime.minutes()}`
          : totalTime.minutes();
      return `${hours}:${minutes}`;
    },
    sumRealWorkTime(work_time, sabatical_time) {
      if (sabatical_time) {
        let workTimeHour = moment.duration(work_time).hours();
        let workTimeminute = moment.duration(work_time).minutes();
        let totalTimeminute =
          workTimeHour * 60 + workTimeminute - sabatical_time * 8 * 60;

        let realTimeHour = Math.floor(totalTimeminute / 60);
        if (realTimeHour < 10) realTimeHour = "0" + realTimeHour;
        let realTimeMinute = Math.round(totalTimeminute % 60);
        if (realTimeMinute < 10)
          realTimeMinute = "0" + Math.round(realTimeMinute);
        return `${realTimeHour}:${realTimeMinute}`;
      }

      return work_time
        ? moment(work_time, "HH:mm")
            // .subtract(moment.duration({ hours: 1, minutes: 30 }))
            .format("HH:mm")
        : "-";
    },

    async fetchUserTimeSheetData() {
      await this.$store.dispatch("timeSheet/fetchEmployeeTimesheetDetail", {
        start_date: moment(this.month, "MM/YYYY")
          .startOf("month")
          .format("DD/MM/YYYY"),
        end_date: moment(this.month, "MM/YYYY")
          .endOf("month")
          .format("DD/MM/YYYY"),
        employee_info: this.employee_id,
      });
      // this.searchData.paginate = this.pagination;
    },
    async fetchTimesheetDashboard() {
      await this.$store.dispatch("timeSheet/fetchEmployeeTimesheetSummary", {
        start_date: moment(this.month, "MM/YYYY")
          .startOf("month")
          .format("DD/MM/YYYY"),
        end_date: moment(this.month, "MM/YYYY")
          .endOf("month")
          .format("DD/MM/YYYY"),
        employee_info: this.employee_id,
      });
    },
    async fetchTimesheetTotalRequest() {
      await this.$store.dispatch("timeSheet/fetchEmployeeTotalRequest", {
        month: this.month,
        employee_info: this.employee_id,
      });
    },

    async fetchAllData() {
      this.setLoading(true);
      await Promise.all([
        this.fetchTimesheetDashboard(),
        this.fetchTimesheetTotalRequest(),
        this.fetchUserTimeSheetData(),
      ]).finally(() => {
        this.setLoading(false);
      });
    },
    classDayOff(data) {
      if (data === 1) {
        return "day-off";
      } else if (data === 2 || data === 3) {
        return "holiday-off";
      }
    },
    checkIsWeekend(day_of_week) {
      let isWeekend = false;
      if (day_of_week === "sunday" || day_of_week === "saturday") {
        isWeekend = true;
      }
      return isWeekend;
    },
    formatNumber(number) {
      return Math.round(number * 100) / 100;
    },
  },
};
</script>

<style lang="scss" scoped>
.time-sheet {
  margin-top: -20px;
  @media screen and (max-width: 740px) {
    margin-top: 12px;
  }
  .table-list {
    margin: 12px 0 0;
    .card-body {
      position: relative;
      padding: 19px 24px 30px;
      .card__header {
        height: 55px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        // padding: 10px 0;

        .card-header__content {
          font-weight: 700;
          font-size: 18px;
          color: #3d4cdc;
        }
      }
    }

    .cl-pointer {
      cursor: pointer;
      .icon-sort {
        margin-left: 5px;
        .c-icon {
          width: 12px;
        }
        .sort-rotate {
          transform: rotate(180deg);
        }
      }
    }

    .work_date {
      text-align: center;
    }

    .employee__badge {
      background: #eff2f7;
      border-radius: 73px;
      padding: 4px 10px;
      font-weight: 700;

      .img__higher {
        filter: brightness(0) saturate(100%) invert(70%) sepia(52%)
          saturate(4593%) hue-rotate(347deg) brightness(101%) contrast(92%);
      }

      .span__higher {
        color: #f58722;
      }
      .span__lower {
        color: #0fa868;
      }
    }
    .day-off {
      background-color: #fff4e4;
    }
    .holiday-off {
      background-color: rgba(223, 49, 91, 0.1);
    }

    .employee__dayoff {
      color: #1190a6;
      font-weight: 700;
    }

    .employee__work {
      color: #0fa868;
      font-weight: 700;
    }

    .employee__holiday-off {
      color: #df315b;
      font-weight: 700;
    }

    .employee__leave {
      color: #f58722;
      font-weight: 700;
    }

    .span__higher {
      color: #f58722;
      font-weight: 700;
    }
    .span__lower {
      color: #0fa868;
      font-weight: 700;
    }
    .action-btn-group {
      display: flex;
      gap: 5px;
      justify-content: center;

      .btn-fix__timeSheet {
        cursor: pointer;
        position: relative;
        width: 34px;
        height: 34px;
        background: #efefef;
        border: 1px solid #dcdcdc;
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
          width: 16px;
          height: 16px;
        }
        .badge {
          position: absolute;
          border-radius: 50%;
          right: 0;
          top: -5px;
          // background: #f03d3e;
          color: #ffffff;
        }
        .tooltip--pending {
          background: #f58722;
        }
        .tooltip--aprove {
          background: #17a896;
        }
        .tooltip--reject {
          background: #f03d3e;
        }
      }
    }
  }
  .time-sheet-statical {
    position: relative;
    // margin: 15px;
    padding: 19px 24px 30px;
    background: #ffffff;
    border-radius: 0.25rem;
    font-weight: 400;
    font-size: 14px;
    .statical-header {
      display: flex;
      justify-content: space-between;
      margin-bottom: 10px;
      .warning-time {
        color: #f58722;
      }
      .normal-time {
        color: #1190a6;
      }
      .submited-time {
        color: #0fa868;
      }
    }
    .statical-content {
      background: #ffffff;
      margin-bottom: 30px;
      .statical-summary {
        display: grid;
        grid-gap: 12px;
        grid-template-columns: calc(50% - 6px) calc(50% - 6px);

        @media screen and (max-width: 768px) {
          grid-template-columns: 100%;
        }
      }

      .statical-item {
        padding: 15px 20px;
        background: #f8f8f8;
        // min-width: 200px;
        width: 100%;
        // height: 100%;
        border-radius: 10px;
        border: 1px solid #e8e8e8;
        font-weight: 400;
        font-size: 14px;
        .item-header {
          padding-bottom: 15px;
          border-bottom: 1px solid #d3d3d3;
          font-weight: 500;
          font-size: 16px;
        }
        .item-footer {
          margin-top: 15px;
          font-weight: 700;
          .real-timesheet-list {
            display: flex;
            width: 100%;
            .real-timesheet-item {
              width: 20%;
              padding: 14px 5px;
              border-right: 1px solid #d3d3d3;
              text-align: center;
              &:last-child {
                border-right: none;
              }
            }
          }
          .list-item {
            display: flex;
            justify-content: space-between;
            margin-bottom: 10px;
          }
          .time-item {
            font-size: 28px;
            margin-bottom: 6px;
          }
          @media screen and (max-width: 767px) {
            .item-mobile {
              border-right: none;
            }
          }
        }
        .text_color--blue {
          color: #3488eb;
        }
        .text_color--red {
          color: #ff5253;
        }
        .text_color--green {
          color: #17a896;
        }
        .text_color--primary {
          color: #3d4cdc;
        }
        .text_color--grey {
          color: #978e8e;
        }
        .minw-50 {
          min-width: 50px;
        }
        .fs-70 {
          font-size: 70px;
          line-height: 70px;
        }
        .fs-28 {
          font-size: 28px;
        }
        .fw-700 {
          font-weight: 700;
        }
        .text_color--red {
          color: #ff5253;
        }
        .item-content {
          display: flex;
          justify-content: space-between;
          width: 100%;
          gap: 15px;
        }
      }
    }
    .statical-footer {
      background: #ffffff;
      display: flex;
      width: 100%;
      .footer-button {
        display: flex;
        margin: 0 auto;
        gap: 10px;
      }
    }
    .footer-btn {
      padding: 10px;
      border-radius: 10px;
      min-width: 200px;
      cursor: pointer;
      outline: none;
      border: none;
      img {
        margin-right: 5px;
      }
    }
    .submit-btn {
      background: #3d4cdc;
      color: #ffffff;
    }
    .compenstate-btn {
      background: #ffffff;
      color: #118fa6;
      border: 1px solid #118fa6;
    }
    .unsubmit-btn {
      background: #ff5253;
      color: #ffffff;
    }
    .btn-disabled {
      background: #e6e6e6;
      color: #9a9a9a;
    }
    .header-title {
      font-weight: 700 !important;
      font-size: 18px !important;
      color: #3d4cdc;
    }
    .month-title {
      color: #147ddf;
      font-weight: 700;
      font-size: 16px;
    }
    &.submit--success {
      background-color: #ebfff7;
      .statical-content {
        background-color: #ebfff7;

        .statical-item {
          border: 2px solid #0fa868;
        }
      }
      .statical-footer {
        background-color: #ebfff7;
      }
      .submited-disable {
        background: #e6e6e6;
        color: #9a9a9a;
      }
    }
    .submit-tick--success {
      position: absolute;
      z-index: 1;
      left: 50%;
      bottom: 50%;
      font-weight: 700;
      font-size: 150px;
      color: #0fa868;
      opacity: 0.1;
      transform: rotate(-30.65deg) translate(-50%, -50%);
      pointer-events: none;
      @media screen and (max-width: 992px) {
        font-size: 100px;
      }
      @media screen and (max-width: 768px) {
        bottom: 80%;
      }

    }
  }
  @media screen and (max-width: 740px) {
    .time-sheet__filter {
      margin: 0;
    }
  }
}
</style>

<style lang="scss">
.submit--success {
  .ant-calendar-picker-input {
    border: 2px solid #0fa868;
  }
}
.time-sheet-statical {
  .ant-calendar-picker-icon {
    width: 20px;
    height: 20px;
    margin-top: -9px;
  }
  .ant-calendar-picker-input {
    width: 212px;
    height: 40px;
    padding: 10px 14px;
    border-radius: 10px;
    color: #147ddf;
    font-weight: 700;
    font-size: 16px;
  }
}
</style>
<style lang="scss" scoped>
/deep/ .modal-content {
  border: none;
  text-align: center;
}
.table-wrapper {
  width: 100%;
  overflow-x: auto;
  border: 1px solid #efefef;
  border-radius: 10px;
}
.table-content {
  min-width: 1130px;
  width: 100%;
  min-height: 170px;
  .table-header {
    tr {
      // border-top: 1px solid #fff;
      border-bottom: 1px solid #fff;
      th {
        padding: 15px 0px;
        min-width: 100px;
        background-color: #3488eb;
        border-right: 1px solid #fff;
        color: #fff;
        text-align: center;
      }
    }
  }
  .table-body {
    tr {
      td {
        padding: 15px 0px;
        border: 1px solid #efefef;
        text-align: -webkit-center;
      }
      td:first-child {
        border-left: none;
      }
      td:last-child {
        border-right: none;
      }
    }
    tr:last-child {
      td {
        border-bottom: none;
      }
    }
  }
  .table-empty {
    position: absolute;
    left: 45%;
    bottom: 50px;
    opacity: 0.6;
  }
}
</style>
